import React from "react";
import { Link, useLocation } from "react-router-dom";
// PERBAIKAN: Menambahkan 'Gamepad2' ke dalam import
import { Home, BookOpen, MessageCircle, User, Gamepad2 } from "lucide-react";

export default function BottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Daftar Menu Navigasi
  const navItems = [
    {
      path: "/",
      label: "Home",
      icon: <Home size={24} />,
    },
    {
      path: "/game",
      label: "Game",
      icon: <Gamepad2 size={24} />, // Ikon Gamepad sekarang akan muncul
    },
    {
      path: "/materi",
      label: "Materi",
      icon: <BookOpen size={24} />,
    },
    {
      path: "/profil",
      label: "Profil",
      icon: <User size={24} />,
    },
  ];

  // Style Khusus Navigasi
  const styles = {
    navContainer: {
      position: "fixed",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
      maxWidth: "480px",
      background: "white",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "12px 0",
      boxShadow: "0 -5px 20px rgba(0,0,0,0.05)",
      borderTop: "1px solid #F1F5F9",
      zIndex: 1000,
      borderRadius: "20px 20px 0 0",
    },
    navItem: (isActive) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textDecoration: "none",
      color: isActive ? "#2563EB" : "#94A3B8",
      fontSize: "10px",
      fontWeight: isActive ? "700" : "500",
      gap: "4px",
      transition: "0.2s",
      minWidth: "60px",
    }),
  };

  return (
    <div style={styles.navContainer}>
      {navItems.map((item) => {
        const isActive = currentPath === item.path;
        return (
          <Link
            key={item.label}
            to={item.path}
            style={styles.navItem(isActive)}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
